import { apolloClient } from "../graphql/apolloClient";
import { FETCH_ENTRIES_DATA } from "../graphql/entriesData";

export function fetchEntriesDataApi({token, params}) {
  return apolloClient.query({
    query: FETCH_ENTRIES_DATA,
    variables: params,
  });
}